
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule as ACommonModule } from '@angular/common';
import { TYTCommonModule } from '@tytapp/common';

import { AboutComponent } from './about/about.component';
import { FaqsComponent } from './faqs/faqs.component';
import { CompanyComponent } from './company/company.component';
import { ContactComponent } from './contact/contact.component';
import { SupportComponent } from './support/support.component';

import { CommonUiModule } from '@tytapp/common-ui';
import { MediaPlaybackModule } from '@tytapp/media-playback';
import { UserModule } from '@tytapp/user';
import { ChatModule } from '@tytapp/chat';
import { ArticlesModule } from '@tytapp/articles';
import { ContentModule } from '@tytapp/content';
import { ShowsSidebarComponent } from './shows-sidebar/shows-sidebar.component';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { externalRedirect } from '@tytapp/app/redirection/redirection.component';

@NgModule({
    imports: [
        FormsModule,
        ACommonModule,
        TYTCommonModule,
        CommonUiModule,
        ArticlesModule,
        UserModule,
        MediaPlaybackModule,
        ChatModule,
        MatIconModule,
        MatButtonModule,
        RouterModule.forChild([
            externalRedirect('faq', 'https://help.tyt.com'),
            externalRedirect('faqs', 'https://help.tyt.com'),

            { path: 'company', component: CompanyComponent },
            { path: 'honor-roll', redirectTo: '/honor-roll' },
            { path: 'contact', component: ContactComponent },
            { path: 'support', component: SupportComponent },
            { path: 'announcements', redirectTo: 'announcement' },
            { path: '', component: AboutComponent, data: { reuse: true } },
            { path: ':section/:subID', component: AboutComponent, data: { reuse: true } },
            { path: ':section', component: AboutComponent, data: { reuse: true } },

        ]),
        ContentModule,
    ],
    declarations: [
        ShowsSidebarComponent,
        AboutComponent,
        FaqsComponent,
        CompanyComponent,
        ContactComponent,
        SupportComponent,
    ],
    exports: [
        AboutComponent,
        FaqsComponent,
        CompanyComponent,
        ContactComponent,
        SupportComponent,
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AboutPagesModule {
    static forRoot(): ModuleWithProviders<AboutPagesModule> {
        return {
            ngModule: AboutPagesModule,
            providers: []
        };
    }
}
